window.AssetsUploader = require('./embeddedUpload');
